import React from "react";
import styled from "styled-components";

import LineSeedKrBd from "../../../../atoms/text/lineSeedKr/lineSeedKrBd";

const LSBdBody01 = (props) => {
  return <LSBdBody01Wrapper {...props} />;
};

export default LSBdBody01;

const LSBdBody01Wrapper = styled(LineSeedKrBd)`
  font-size: 14px;
  font-weight: 700;
  line-height: 19.6px;
  letter-spacing: -0.3px;

  color: #222222;
`;
